import createIcon from '../../createIcon';

/**
 * @component @name MarkChatRead
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTYuODQgMjBMMTMuMyAxNi40NkwxNC43MSAxNS4wNUwxNi44MyAxNy4xN0wyMS4wNyAxMi45M0wyMi41IDE0LjM0TDE2Ljg0IDIwWk0xMS41IDE3QzExLjUgMTMuMTMgMTQuNjMgMTAgMTguNSAxMEMxOS41OCAxMCAyMC41OSAxMC4yNSAyMS41IDEwLjY4VjRDMjEuNSAyLjkgMjAuNiAyIDE5LjUgMkgzLjVDMi40IDIgMS41IDIuOSAxLjUgNFYyMkw1LjUgMThIMTEuNUMxMS41IDE3LjgzIDExLjUxIDE3LjY3IDExLjUzIDE3LjVDMTEuNTEgMTcuMzQgMTEuNSAxNy4xNyAxMS41IDE3WiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const MarkChatRead = createIcon('MarkChatRead', [
  [
    'path',
    {
      d: 'M16.84 20L13.3 16.46L14.71 15.05L16.83 17.17L21.07 12.93L22.5 14.34L16.84 20ZM11.5 17C11.5 13.13 14.63 10 18.5 10C19.58 10 20.59 10.25 21.5 10.68V4C21.5 2.9 20.6 2 19.5 2H3.5C2.4 2 1.5 2.9 1.5 4V22L5.5 18H11.5C11.5 17.83 11.51 17.67 11.53 17.5C11.51 17.34 11.5 17.17 11.5 17Z',
      key: 'k73cjf',
    },
  ],
]);

export default MarkChatRead;
